import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedStories() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            精选故事
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            每一篇故事，都是母辈女性真实而温暖的人生片段
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-100 rounded-lg overflow-hidden hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 bg-primary-500 text-white rounded-full text-xs font-label whitespace-nowrap">
                    精选
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}